import React from 'react'
import ReactDOM from 'react-dom/client'
import reportWebVitals from './reportWebVitals'

import { RouterProvider } from "react-router-dom"
import appRouter from 'routes/router'
import { Provider } from 'react-redux'
import { store } from 'rtk/store'
// import { ContextProvider } from 'core/ContextProvider'

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <React.StrictMode>
    <Provider store={store}>
      {/*<ContextProvider> */}
      <RouterProvider router={appRouter} />
      {/* </ContextProvider>*/}
    </Provider>
  </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
